export default "__VITE_ASSET__77f899e5__"